import React from 'react';
import PaymobLogo from './../../../../../statics/img/esaypaisa/paymob.png';
import Successfull from './../../../../../statics/img/card/successfull_payment.gif';

function SuccessfullPayment() {
    return (
        <div className="payment_status_container successfull">
            <span>Done</span>
            <img src={Successfull} />
            <h3>Payment successful!</h3>
            <p>Thank you for using paymob</p>
            <div className="content">
                <p>Amount paid <span>6544.25 EGP</span></p>
                <hr/>
                <p>Payment method<span>Card ending... 4653</span></p>
            </div>
            <div className="footer">
                <span>Powered by</span>
                <img src={PaymobLogo} />
            </div>
        </div>
    )
}

export default SuccessfullPayment;